<script>
	import place from '$lib/icons/place.svg';

	export let url;
	export let alternativeText;
	export let beschreibung;
	export let link;
	export let wohnflaeche;
	export let preis;
	export let interesse;
	export let ort;
	export let verkauft;
</script>

<a href={link} data-sveltekit-preload-data="hover">
	<div class="container imageBox h-1/5 w-1/4">
		<div class="image {verkauft ? 'verkauft' : ''}">
			<img class="" src={url} alt={alternativeText} />
		</div>
		{#if verkauft}
			<div class="banner">
				<p>Verkauft</p>
			</div>
		{/if}

		<div class="eckdaten {verkauft ? 'verkauft' : ''}">
			<ul>
				<li style="display: flex;align-items:center;">
					<img class="place" src={place} alt="place" />{ort}
				</li>
				<li>{wohnflaeche} m<sup>2</sup></li>
				<li>{interesse ? 'Kaufen' : 'Mieten'}</li>
				<li>
					{#if isNaN(parseInt(preis))}
						{preis}
					{:else}
						{parseInt(preis, 10).toLocaleString('de-DE', {
							style: 'currency',
							currency: 'EUR',
							maximumFractionDigits: 0
						})}
					{/if}
				</li>
			</ul>
		</div>

		<div
			class="flex align-center justify-center absolute items-center bottom-2 w-auto {verkauft
				? 'verkauft'
				: ''}"
		>
			<p class="info">
				{beschreibung}
			</p>
		</div>
	</div>
</a>

<style>
	:root {
		--primary-color: #aa9173;
	}
	.verkauft {
		filter: grayscale(100%) blur(1px);
	}
	.banner {
		position: absolute;
		width: 200%;
		height: 2em;
		outline: solid 2px #aa9173a9;
		background-color: rgb(255, 255, 255);
		transform: rotate(-45deg);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 10;
	}
	.banner p {
		font-size: 1.5rem;
		font-weight: bold;
	}
	.container {
		box-shadow: 2px 2px 15px 3px rgba(0, 0, 0, 0.2);
		transition: all 0.2s ease-in-out;
		margin: 1rem;
		min-width: 300px;
		min-height: 300px;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		overflow: hidden;
		align-items: center;
		background-color: white;
		max-width: 350px;
		max-height: 400px;
		border-radius: 10px;
	}
	.image {
		width: 100%;
		height: 50%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		padding: 0 0 4px 0;
		overflow: hidden;
		display: flex;
		align-items: flex-end;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		transition: all 0.2s ease-in-out;
	}
	.image img {
		transform: scale(1.3);
	}

	li .place {
		width: auto;
		height: 20px;
		margin: 0 0.5rem 0 0;
	}
	li:not(:first-child) {
		padding: 0 1.4rem;
	}
	.container:hover {
		border-radius: 0px;
		box-shadow: 2px 2px 15px 3px #aa9173;
	}
	.container:hover .image img {
		transform: scale(1.4);
	}
	.container:hover .image {
		border-top-left-radius: 0px;
		border-top-right-radius: 0px;
	}
	p {
		hyphens: auto;
		text-align: justify;
		color: var(--primary-color);
	}
	.eckdaten {
		width: 100%;
		height: 100%;
		margin: 6.8rem 0 0 2rem;
		color: var(--primary-color);
	}
	.info {
		white-space: nowrap;
		max-width: 300px;
		font-size: 0.8rem;
		text-align: center !important;
		display: flex;
		justify-content: flex-start;
		padding: 0.5rem 0 0 0;
	}
	.info:before {
		content: '';
		position: absolute;
		top: 0;
		width: 50%;
		height: 2px;
		background-color: var(--primary-color);
	}
	img {
		object-fit: cover;
		transition: all 0.2s ease-in-out;
	}
</style>
